import Vue from 'vue'

export default () => {
  Vue.filter('currency', function (amount, decimals = 2) {
    return parseFloat(amount)
      .toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: decimals,
      })
      .replace('$', '')
  })

  Vue.filter('truncate', function (text, length, suffix = '...') {
    if (text.length > length) {
      return text.substring(0, length) + suffix
    } else {
      return text
    }
  })
}